import type * as api from '@gitbook/api-client';
import type { NavigationSiteInsightsReports } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import type { IconDefinition } from '@gitbook/spine-react';

/**
 * Centralized definition of the tabs available in the site insights section.
 */
export const siteInsightTabs: Array<{
    id: (typeof NavigationSiteInsightsReports)[number];
    label: string;
    icon: IconDefinition;
    visible?: (site: api.Site) => boolean;
}> = [
    {
        id: 'traffic',
        label: 'Traffic',
        icon: Icon.Globe,
    },
    {
        id: 'ads',
        label: 'Ads & sponsorship',
        icon: Icon.PaidMember,
        visible: (site) => Boolean(site.ads),
    },
    {
        id: 'pages',
        label: 'Pages & feedback',
        icon: Icon.AddPageGroup,
    },
    {
        id: 'urls',
        label: 'Broken URLs',
        icon: Icon.LinkBroken,
    },
    {
        id: 'search',
        label: 'Search',
        icon: Icon.Search,
    },
    {
        id: 'ask',
        label: 'Ask AI',
        icon: Icon.SearchOrAsk,
    },
    {
        id: 'links',
        label: 'Links',
        icon: Icon.Link,
    },
    {
        id: 'openapi',
        label: 'OpenAPI',
        icon: Icon.OpenAPI,
    },
];
